import { render, staticRenderFns } from "./TitleList.vue?vue&type=template&id=22681522&scoped=true&"
import script from "./TitleList.vue?vue&type=script&lang=ts&"
export * from "./TitleList.vue?vue&type=script&lang=ts&"
import style0 from "./TitleList.vue?vue&type=style&index=0&id=22681522&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22681522",
  null
  
)

export default component.exports